// This is just some sample data so you don't have to think of your own!
module.exports = ['Landscapes', 'Marine', 'Misc', 'Urban'];


// WEBPACK FOOTER //
// ./src/components/data.js